import Select, { Props, StylesConfig } from 'react-select'

const customStyles: StylesConfig<any, boolean> = {
  control: (base: any) => ({
    ...base,
    borderColor: '#dee2e6',
    borderRadius: '0.6rem',
    backgroundColor: '#fff',
    '&:hover': {
      borderColor: '#4f38e0',
    },
    '&:focus-within': {
      borderColor: '#4f38e0',
      boxShadow: '0 0 0 0.2rem rgba(79, 56, 224, 0.25)',
    },
  }),
  option: (base: any, state: any) => ({
    ...base,
    backgroundColor: state.isSelected ? '#4f38e0' : state.isFocused ? '#f8f9fa' : '#fff',
    color: state.isSelected ? '#fff' : '#000',
    borderRadius: state.isSelected ? 0 : '0.6rem',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: state.isSelected ? '#4f38e0' : '#f8f9fa',
    },
  }),
  menuList: (base: any) => ({
    ...base,
    borderRadius: '0.6rem',
  }),
  singleValue: (base: any) => ({
    ...base,
    color: '#000',
  }),
  multiValue: (base: any) => ({
    ...base,
    backgroundColor: '#4f38e0',
    borderRadius: '0.6rem',
    padding: '4px 8px',
  }),
  multiValueLabel: (base: any) => ({
    ...base,
    color: '#fff',
    padding: '0 4px',
  }),
  multiValueRemove: (base: any) => ({
    ...base,
    color: '#fff',
    cursor: 'pointer',
    padding: '0 4px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.2)',
      color: '#fff',
    },
  }),
}

export default function CustomSelect<Option = {
  label: string
  value: any
}, IsMulti extends boolean = true>(
  props: Props<Option, IsMulti>,
) {
  return (
    <Select<Option, IsMulti>
      styles={customStyles}
      {...props}
    />
  )
}
